export default __webpack_public_path__ + "static/media/menu.b15501ff.svg";